import type { IconProps } from './types';

export function SaidaDePraia({ size = 24, ...props }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 256 256"
      fill="none"
      stroke="currentColor"
      strokeWidth="14"
      strokeLinejoin="round"
      strokeLinecap="round"
      {...props}
    >
      <path d="M76 52 Q98 48 120 52 Q124 82 128 112 Q132 82 136 52 Q158 48 180 52 Q204 56 232 68 Q232 100 232 144 Q224 148 216 148 Q200 146 188 144 Q190 180 192 216 Q128 220 64 216 Q66 180 68 144 Q56 146 40 148 Q32 148 24 144 Q24 100 24 68 Q52 56 76 52 Z" />
    </svg>
  );
}
